import React from "react"
import { isBlackFridayLastMinutePopupActive } from "utils/dateUtils"
import { ENABLE_BLACK_FRIDAY_LAST_MINUTE_POPUP } from "config/campaignFeatureToggles"
import BfPopup from "views/productsList/blackFriday/BfPopup"

/** Black Friday 2026 popup no. 2: the last day, 08:00 - 20:00. */
const BlackFridayLastMinutePopup = () => {
  if (!ENABLE_BLACK_FRIDAY_LAST_MINUTE_POPUP) return null
  if (!isBlackFridayLastMinutePopupActive()) return null

  return <BfPopup variant="last" storageKey="blackFridayLastMinutePopup2026Dismissed" />
}

export default BlackFridayLastMinutePopup
